<template>
  <div class="content-wrapper">
    <h2 class="page-titles">Settings</h2>

    <template v-if="isTeamOwner">
      <transition name="slide-fade">
        <component :is="paigeSettings"></component> </transition
    ></template>
    <template v-else>
      <component :is="paigeSettings" v-if="tabs[0].isActive"></component>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { layouts, storeModules } from '../helpers'
import PaigeSettings from '../components/Profile/PaigeSettings'
import LitePaigeSettings from '../components/Profile/LitePaigeSettings'
import SSOSettings from '../components/Profile/SSOSettings'

export default {
  name: 'ProfileMain',
  components: {
    Tabs: () => import('@/components/Universal/Tabs'),
    PaigeSettings,
    LitePaigeSettings,
    SSOSettings
  },

  data() {
    return {
      tabs: [
        { name: 'General', isActive: true },
        { name: 'IDP Settings', isActive: false }
      ]
    }
  },

  methods: {
    setActiveTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name === selectedTab.name
      })
    }
  },

  computed: {
    ...mapState({
      team: state => state.team.team,
      user: state => state.profile.user
    }),
    paigeSettings() {
      if (
        this.team.teamModuleNames.includes(storeModules.swag_store) ||
        this.team.teamModuleNames.includes(storeModules.e_commerce)
      ) {
        return 'PaigeSettings'
      }

      return 'LitePaigeSettings'
    },
    isTeamOwner() {
      return (
        this.user && this.user.roles && this.user.roles.includes('team_owner')
      )
    }
  },

  created() {
    // this.$store.dispatch('profile/getIDPSettings')
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
  }
}
</script>

<style scoped lang="scss"></style>
